package ui.screens.section.brideandgroom.composable

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.jetbrains.compose.resources.painterResource
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.candles
import thewedding_cmp.composeapp.generated.resources.moon
import thewedding_cmp.composeapp.generated.resources.photo_0
import thewedding_cmp.composeapp.generated.resources.stars
import ui.screens.section.brideandgroom.cutoutShape
import ui.theme.ColorScheme

@Composable
fun GroomSection(
    textColor: Color,
    imageHeight: Dp,
    imageWidth: Dp,
    decorationSize: Dp,
    safeEntered: Boolean,
) {
    Column {
        Box(
            Modifier.height(imageHeight).fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Image(
                painterResource(Res.drawable.moon),
                modifier = Modifier
                    .align(Alignment.TopCenter)
                    .padding(start = imageWidth / 1.10f)
                    .height(decorationSize)
                    .width(decorationSize),
                contentDescription = null,
            )
            Image(
                painterResource(Res.drawable.photo_0),
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .height(imageHeight)
                    .width(imageWidth)
                    .border(
                        3.dp,
                        ColorScheme.secondary,
                        cutoutShape
                    )
                    .clip(cutoutShape)
                    .background(Color.White)
                    .padding(8.dp)
                    .border(
                        2.dp,
                        ColorScheme.secondary,
                        cutoutShape
                    )
                    .clip(cutoutShape),
                contentScale = ContentScale.Crop,
                contentDescription = null,
            )
            Image(
                painterResource(Res.drawable.stars),
                modifier = Modifier
                    .align(Alignment.TopCenter)
                    .padding(end = imageWidth / 2f)
                    .height(decorationSize)
                    .width(decorationSize * 1.7f),
                contentDescription = null,
            )
            Image(
                painterResource(Res.drawable.candles),
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .height(decorationSize / 2.4f)
                    .width(imageWidth - 28.dp),
                contentDescription = null,
            )
        }

        Text(
            "Helmy Danu Prameireza",
            modifier = Modifier
                .padding(start = 8.dp, end = 8.dp, top = 32.dp)
                .align(Alignment.CenterHorizontally),
            textAlign = TextAlign.Center,
            style = MaterialTheme.typography.titleLarge.copy(
                fontWeight = FontWeight.Normal,
                fontSize = 46.sp,
            ),
            color = textColor,
        )

        Text(
            "Putra dari bapak Haryanto",
            modifier = Modifier
                .padding(start = 8.dp, end = 8.dp, top = 4.dp)
                .align(Alignment.CenterHorizontally),
            style = MaterialTheme.typography.titleSmall.copy(
                fontWeight = FontWeight.Normal,
            ),
            color = textColor,
        )

        Text(
            "& ibu Trini Titi Mursidah",
            modifier = Modifier
                .padding(start = 8.dp, end = 8.dp, top = 4.dp, bottom = 64.dp)
                .align(Alignment.CenterHorizontally),
            style = MaterialTheme.typography.titleSmall.copy(
                fontWeight = FontWeight.Normal,
            ),
            color = textColor,
        )
    }
}